<template lang="pug">
  v-container#top(fluid)
    v-layout.jumbotron(column align-center)
      v-flex.jumbotron-contents.text-xs-center
        h1.display-4(style="padding-bottom:0.3em;") Wanted
    v-layout#latest-releases(align-center)
      v-flex.text-xs-center
        v-layout(fill-height justify-center row wrap)
          v-card(v-for="wanted in wanted_list" :key="wanted")
            v-layout.wanted-card.elevation-5.grey.darken-4(row)
              v-flex
                v-card-title
                  p.caption(style="margin:0") {{ wanted.id }}
                  p.display-1 {{ wanted.title }}
                  p.headlines {{ wanted.subtitle }}
                v-card-media
                  a(:href="wanted.id")
                    img.wanted_img(:src="require('../assets/images/wanted/' + wanted.img_url)" width="300")
                v-card-actions
                  p.headlines.grey--text Theme: {{ wanted.theme }}
                  p.headlines {{ wanted.lead_text }}
                  p.headlines Deadline: {{ wanted.deadline }}
                  v-list.grey.darken-4
                    v-list-group(no-action)
                      v-expansion-panel
                        v-expansion-panel-content
                          div(slot="header")
                            v-card
                              v-card-content(v-for="p in wanted.regulation" :key="p")
                                p {{ p }}
                              //v-btn.hrefbutton.primary(:href="wanted.upload_url") File Uploader
                              v-btn.hrefbutton.green(:href="wanted.form_url" disabled) Submit Form

        v-btn.hrefbutton(href="about") About
          i.fas.fa-chevron-circle-right
        v-btn.hrefbutton.blue(href="contact") Contact
          i.fas.fa-chevron-circle-right

</template>

<script>
let db = require('@/assets/db.json');
let wanteds = db.wanted
export default {
  data () {
    return {
      wanted_list: wanteds
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
i {
  margin-left: 0.5em;
}
@mixin display-size-page {
  min-height: 100vh;
  min-width: 100vw;
  padding-right: 10%;
  padding-left: 10%;
}
#top {
  padding: 0;
}
#latest-releases {
  @include display-size-page;
  padding-top: 5em;
  padding-bottom: 3em;
  padding-right: 0;
  padding-left: 0;
}
.jumbotron {
  @include display-size-page;
  background-size: cover;
  background-position: center;
  background-image: url("../assets/images/sub.jpg");
}
.jumbotron-contents {
  @include display-size-page;
  padding-top: 30vh;
  background: rgba(0,0,0,0.4)
}
.hrefbutton {
  margin-top: 2em;
  width: 150px;
}
.wanted-img {
  margin-bottom: 1em;
  border-radius: 5px;
}
.wanted-card {
  padding: 30px 10px 30px 10px;
  margin: 30px 10px 30px 10px;
  border-radius: 5px
}
</style>
